import { actionTypes, GATEWAY_MAIN_TYPES, GATEWAY_SUB_TYPES } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const getGatewayListAction = getApiActionCreator(actionTypes.GET_GATEWAY_LIST_SETTINGS);
export const getDriveApplicationAction = getApiActionCreator(actionTypes.GET_DRIVE_APPLICATIONS_SETTINGS);
export const getUpdateAssetDriveApplicationAction = getApiActionCreator(actionTypes.GET_UPDATE_ASSET_DRIVE_APPLICATION_SETTINGS);

export const getGatewayList = (organizationID, siteId = [], filter = null, gatewayFilter = null) => {
    const payload = {};

    const hasKeyword = filter?.keyword && filter.keyword.trim().length > 0;
    const isEmptyOrUnknownTab = gatewayFilter?.type === GATEWAY_MAIN_TYPES.OTHER_GATEWAYS &&
        (gatewayFilter?.subType === GATEWAY_SUB_TYPES.EMPTY || gatewayFilter?.subType === GATEWAY_SUB_TYPES.UNKNOWN);

    // Don't send organizationID and siteId for Empty/Unknown gateways tabs or when searching
    if (!hasKeyword && !isEmptyOrUnknownTab) {
        payload.organizationID = organizationID;
        payload.siteId = siteId;
    }

    if (filter?.keyword) {
        payload.filter = encodeURIComponent(filter?.keyword.trim());
    }

    if (filter?.gatewayType) {
        payload.gatewayType = filter.gatewayType;
    }

    if (filter?.summaryConnectionStatus?.length > 0) {
        payload.summaryConnectionStatus = filter.summaryConnectionStatus;
    }

    if (gatewayFilter) {
        payload.gatewayFilter = gatewayFilter;
    }

    return {
        type: actionTypes.GET_GATEWAY_LIST,
        payload
    };
};

export const getGatewayTypeAction = getApiActionCreator(actionTypes.GET_GATEWAY_TYPE_SETTINGS);

export const getGatewayType = () => {
    return {
        type: actionTypes.GET_GATEWAY_TYPE
    };
};

export const setSelectedGateway = (selectedGateway) => {
    return {
        type: actionTypes.SET_SELECTED_GATEWAY,
        selectedGateway
    };
};

export const openSerialNumberEditorModal = () => {
    return {
        type: actionTypes.OPEN_SERIAL_NUMBER_EDITOR_MODAL
    };
};

export const closeSerialNumberEditorModal = () => {
    return {
        type: actionTypes.CLOSE_SERIAL_NUMBER_EDITOR_MODAL
    };
};

export const selectAsset = (selectedAssetDetails) => {
    return {
        type: actionTypes.SELECT_ASSET,
        selectedAssetDetails
    };
};


export const getDriveApplications = () => ({
    type: actionTypes.GET_DRIVE_APPLICATIONS
});

export const clearDriveApplications = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_DRIVE_APPLICATIONS });
    };
};

export const getUpdateAssetDriveApplication = (payload, gatewayID) => ({
    type: actionTypes.GET_UPDATE_ASSET_DRIVE_APPLICATION,
    payload,
    gatewayID
});


export const clearStore = () => {
    return (dispatch) => {
        dispatch({ type: actionTypes.CLEAR_STORE });
    };
};
